import React from "react";
import styled from "styled-components";

const Head = styled.span`
  flex: 0 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const MiddleEllipsisTail = styled.span`
  flex: 0 0 auto;
  white-space: nowrap;
`;

const MiddleEllipsisLabel = ({ text, tailLength = 10 }) => {
  if (!text) return null;
  if (text.length <= tailLength + 2) {
    return <MiddleEllipsisTail>{text}</MiddleEllipsisTail>;
  }
  return (
    <>
      <Head>{text.slice(0, text.length - tailLength)}</Head>
      <MiddleEllipsisTail>{text.slice(-tailLength)}</MiddleEllipsisTail>
    </>
  );
};

export default MiddleEllipsisLabel;
